module.exports = __webpack_public_path__ + "static/media/Kanit-Regular.b935eb67.ttf";